import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { startOfMinute } from "date-fns";
import type { GigBoardArgs } from "domains/schedule/containers/GigBoard/queries";
import type { MarketplaceSearch } from "domains/schedule/utils/useMarketplaceSearch";
import type { WarmableQuery } from "routing/warmQueries";
import { queries as gigViewLayoutQueries } from "../GigViewLayout/queries";

type QueriesInput = {
  search: MarketplaceSearch;
  location: ForManagerLocationDetail | undefined;
  now: Date;
  isAdmin: boolean;
  includeWorkingInterviews: boolean;
};

export const scheduleGigArgs = (now: Date): GigBoardArgs => ({
  viewType: "SCHEDULE",
  end_time__gte: startOfMinute(now),
  ordering: "start_time, -id",
});

export const queries = ({
  search,
  location,
  now,
  isAdmin,
  includeWorkingInterviews,
}: QueriesInput): Array<WarmableQuery> =>
  gigViewLayoutQueries({
    search,
    location,
    now,
    isAdmin,
    includeWorkingInterviews,
    defaultView: "calendar",
    queryArgs: scheduleGigArgs,
  });
